import { cn } from '@attive/ui/cn'
import * as React from 'react'

interface KbdProps {
	children: React.ReactNode
	className?: string
	/**
	 * When true, renders without box styling (no border/background).
	 * Useful for inline key hints inside buttons.
	 */
	inline?: boolean
}

export function Kbd({ children, className, inline = false }: KbdProps) {
	return (
		<kbd
			className={cn(
				'inline-flex items-center font-mono text-sm capitalize',
				inline
					? 'opacity-60'
					: 'ml-1.5 rounded border border-muted-foreground/20 px-1.5 py-0.5',
				className,
			)}
		>
			{children}
		</kbd>
	)
}

// Helper function to detect OS and return appropriate shortcut
export function getOSModifier() {
	if (typeof window === 'undefined') return 'Ctrl'
	return navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? '⌘' : 'Ctrl'
}

// Common keyboard shortcuts
export const shortcuts = {
	save: () => `${getOSModifier()} + Enter`,
	saveSymbol: () => `${getOSModifier()} ⏎`,
	enter: () => '⏎',
} as const
